import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';
import { capitalCase } from 'change-case';
import {
  formatCurrency,
  getPercentageSaved,
  localeCompare,
} from '../../utils/helpers';
import { PAYMENT_INTERVAL } from '../../constants/app';
import { setSelectedPlan } from '../../store/action/products';
import { setItem } from '../../utils/cache';

const SubscriptionSelector = ({ lightTheme }) => {
  const { products, selectedPlan } = useSelector(state => state.product);
  const dispatch = useDispatch();
  const handlePlanSelect = plan => {
    dispatch(setSelectedPlan(plan));
    setItem('selectedPlan', JSON.stringify(plan));
  };
  const offValue = getPercentageSaved(products);
  const yearlyPlan = products?.find(
    product => product?.attributes?.interval === PAYMENT_INTERVAL.YEARLY,
  );

  const getLabel = interval => {
    if (interval === PAYMENT_INTERVAL.MONTHLY) {
      return 'Monthly';
    } else if (interval === PAYMENT_INTERVAL.YEARLY) {
      return 'Yearly';
    }
    return interval;
  };
  useEffect(() => {
    const plan = products?.find(
      product =>
        product?.attributes?.interval === selectedPlan?.attributes?.interval,
    );
    setItem('selectedPlan', JSON.stringify(plan));
  }, [products, selectedPlan]);

  return (
    <div className="subscription-selector">
      <div
        className={clsx(
          'd-flex flex-column justify-content-between subscription-detail-boxs',
        )}
      >
        {(products || [])
          .sort((a, b) =>
            localeCompare(a?.attributes?.interval, b?.attributes?.interval),
          )
          .map(plan => (
            <div
              key={plan.id}
              onClick={() => handlePlanSelect(plan)}
              className={clsx(
                'plan-radio-group position-relative',
                selectedPlan?.id === plan.id && 'selected-plan',
                lightTheme && 'light-theme-plan',
              )}
            >
              <Form.Check
                htmlFor={capitalCase(getLabel(plan?.attributes?.interval))}
                checked={selectedPlan?.id === plan.id}
                value={plan.id}
                type="radio"
                onChange={() => handlePlanSelect(plan)}
              />
              <div className="month-price">
                <div className="d-flex justify-content-between type-price">
                  <div>
                    <div className="interval">
                      {capitalCase(getLabel(plan?.attributes?.interval))}
                    </div>
                    <span className="description">
                      {plan.attributes.description}
                    </span>
                  </div>

                  <div className="cut-price-div">
                    {plan.attributes.interval === 'year' && (
                      <div className="cut-price">
                        {formatCurrency(300, plan.attributes.currency, 2)}
                      </div>
                    )}
                    <div className="amount">
                      {formatCurrency(
                        plan.attributes.interval === 'year'
                          ? +plan.attributes.amount_in_cents / 100 / 12
                          : +plan.attributes.amount_in_cents / 100,
                        plan.attributes.currency,
                      )}
                      /mo
                    </div>
                  </div>
                </div>
              </div>
              {yearlyPlan?.id === plan.id && offValue ? (
                <div className="off_tag">
                  Save&nbsp;<span>{offValue}</span>%
                </div>
              ) : (
                ''
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

SubscriptionSelector.propTypes = {
  lightTheme: PropTypes.bool,
};

export default SubscriptionSelector;
